<template>
  <div class="p-6 bg-white rounded-lg">
    <div class="flex items-center mb-4 pb-4 border-b">
      <div
        class="w-12 h-12 rounded-lg text-white cursor-pointer"
        :class="this.module.settings.icon_color ? this.module.settings.icon_color : 'bg-tertiary'"
        @click="iconPickerVisible = true"
      >
        <!-- <i class="fas fa-2x" :class="`fa-${this.module.settings.icon}`" /> -->
        <icon v-if="this.module.settings.icon" :name="this.module.settings.icon" class="text-white" />
      </div>
      <h3 class="text-2xl font-medium ml-4">{{ this.module.title }}</h3>
    </div>

    <select-input
      v-model="module.settings.event_ticket_id"
      placeholder="Click to select linked event"
      label="Bind to Event"
      option-key="name"
      option-value="ticket_id"
      class-name="mb-2"
      :options="events"
    />

    <input type="text" placeholder="Title" class="input-sm w-full mb-4" v-model="module.title" required>

    <textarea rows="3" class="input-sm w-full mb-4" placeholder="Description" v-model="module.settings.description" required></textarea>

    <modal v-if="iconPickerVisible" :scrollY="false">
      <icon-picker />
    </modal>
  </div>
</template>

<script>
import { EventBus } from '@/EventBus'
import IconPicker from '@/components/IconPicker'
import { v2Api } from '@/http'
import { mapState } from 'vuex'

export default {
  components: { IconPicker },

  props: ['module'],

  data () {
    return {
      iconPickerVisible: false,
      events: []
    }
  },
  computed: {
    ...mapState({
      office: state => state.selectedOffice
    })
  },
  methods: {
    saved (data) {
      if (this.iconPickerVisible) {
        this.iconPickerVisible = false
        this.$set(this.module.settings, 'icon', data.icon)
        this.$set(this.module.settings, 'icon_color', data.color)
      }
    },

    cancelled () {
      this.iconPickerVisible = false
    },

    getTicketEvents () {
      v2Api.get(`/event-tickets`, {
        params: {
          network_id: this.office.network_id,
          no_page: true
        }
      }).then((response) => {
        this.events = response.data
      }).catch(() => {
        alert('Unable to get event lists')
      })
    }
  },

  created () {
    EventBus.$on('icon-picker:cancel', this.cancelled)
    EventBus.$on('icon-picker:saved', this.saved)
    this.getTicketEvents()
  },

  beforeDestroy () {
    EventBus.$off('icon-picker:cancel', this.cancelled)
    EventBus.$off('icon-picker:saved', this.saved)
  }
}
</script>
